import { render, staticRenderFns } from "./LiveSessionPage.vue?vue&type=template&id=5f0c4941&scoped=true"
import script from "./LiveSessionPage.vue?vue&type=script&lang=js"
export * from "./LiveSessionPage.vue?vue&type=script&lang=js"
import style0 from "./LiveSessionPage.vue?vue&type=style&index=0&id=5f0c4941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c4941",
  null
  
)

export default component.exports